import { useEffect, useMemo, useState } from "react";
import api from "../api/api";

/**
 * Fetches ministries and returns:
 * - options: [{ value:id, label:name }]
 * - byId: Map(id -> {value,label})
 * - loading, error
 */
export default function useMinistries() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const res = await api.get("/ministries"); // [{id,name,active}]
        const opts =
          (res.data || [])
            .filter((m) => m.active !== false)
            .map((m) => ({ value: m.id, label: m.name })) ?? [];
        if (mounted) {
          setOptions(opts);
          setError(null);
        }
      } catch (e) {
        if (mounted) setError(e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const byId = useMemo(() => {
    const map = new Map();
    for (const o of options) map.set(o.value, o);
    return map;
  }, [options]);

  return { options, byId, loading, error };
}
